const MB_imageCompressorUtils = {
  fileIsTooLargeString: (maxSize: number) => {
    return 'File is too large.\nPlease try an image less than ' + maxSize / (1024 * 1024) + ' MB.';
  },
};

export { MB_imageCompressorUtils };
